import { type FormEvent, useEffect, useState } from 'react';
import { Alert, Box, Button, Link, Stack, TextField, Typography } from '@mui/material';
import { AuthLayout } from '../components/AuthLayout';
import { PasswordField } from '../components/PasswordField';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { clearAuthFeedback, login } from '../store/authSlice';

export function LoginPage() {
  const dispatch = useAppDispatch();
  const { loginStatus, error } = useAppSelector((state) => state.auth);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const rejected = new URLSearchParams(window.location.search).has('error');
  const passwordWasReset = new URLSearchParams(window.location.search).get('reset') === 'success';
  const busy = loginStatus === 'submitting';
  const loginError = error === 'ERR_PASSWORD_EXPIRED'
    ? 'Ihr Passwort ist abgelaufen. Verwenden Sie „Passwort vergessen“, um es zu aktualisieren.'
    : error;

  useEffect(() => () => { dispatch(clearAuthFeedback()); }, [dispatch]);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    const action = await dispatch(login({ email, password }));
    if (login.fulfilled.match(action)) window.location.assign('/');
  };

  return (
    <AuthLayout>
      <Typography component="h1" variant="h2">Anmeldung</Typography>
      {(loginError || rejected) && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {loginError || 'Fehler. Überprüfen Sie Ihre Eingaben oder versuchen Sie es später erneut.'}
        </Alert>
      )}
      {passwordWasReset && <Alert severity="success" sx={{ mt: 2 }}>Ihr Passwort wurde geändert. Sie können sich jetzt anmelden.</Alert>}
      <Stack component="form" onSubmit={submit} spacing={2} sx={{ mt: 2 }}>
        <TextField
          label="E-Mail oder Benutzername"
          name="login-email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          autoFocus
          required
          autoComplete="username"
          error={Boolean(error)}
        />
        <PasswordField
          label="Passwort"
          name="login-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
          autoComplete="current-password"
          error={Boolean(error)}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, pt: 1 }}>
          <Link href="/recovery" underline="hover">Passwort vergessen?</Link>
          <Button type="submit" variant="contained" disabled={!email || !password || busy} sx={{ width: 148 }}>
            {busy ? 'Verbinde …' : 'Anmelden'}
          </Button>
        </Box>
      </Stack>
    </AuthLayout>
  );
}
